/**
 * ========================================
 * COLOR SWATCHES - PRODUCTION v1.1
 * ========================================
 * Fast AJAX product switching with full tracking
 * Optimized for speed and compatibility
 * + Size selection persistence across color changes
 */

// Suppress harmless resource loading errors
window.addEventListener('error', function(e) {
  if (!e.target) return;
  
  const tag = e.target.tagName;
  const href = e.target.href || '';
  
  if (['SOURCE', 'TRACK', 'VIDEO', 'AUDIO'].includes(tag)) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
  
  if (tag === 'LINK' && href.includes('undefined')) {
    e.target.remove();
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
  
  if (['SCRIPT', 'IMG', 'IFRAME'].includes(tag)) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
  
  if (e.message && e.message.includes('Identifier') && e.message.includes('already been declared')) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
}, true);

window.currentProductContext = null;

function initColorSwatches() {
  const container = document.querySelector("#ColorSwatches");
  if (!container) return;

  const newContainer = container.cloneNode(true);
  container.parentNode.replaceChild(newContainer, container);

  newContainer.addEventListener("click", async (e) => {
    const btn = e.target.closest(".color-swatch");
    if (!btn) return;

    const handle = btn.dataset.handle;
    if (!handle || btn.classList.contains("is-active")) return;

    btn.classList.add("loading");

    try {
      const currentSection = 
        document.querySelector(".product-single") ||
        document.querySelector(".product-section") ||
        document.querySelector(".product") ||
        document.querySelector("[class*='product-container']") ||
        document.querySelector("[data-section-type*='product']") ||
        document.querySelector("main .shopify-section") ||
        document.querySelector("#MainContent");

      if (!currentSection) throw new Error("Product section not found");

      const productDataPromise = fetch(`/products/${handle}.js`).then(r => r.json());
      const response = await fetch(`/products/${handle}`);
      if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      let newSection;
      if (currentSection.id) newSection = doc.querySelector(`#${currentSection.id}`);
      if (!newSection && currentSection.className) {
        const firstClass = currentSection.className.split(' ')[0];
        newSection = doc.querySelector(`.${firstClass}`);
      }
      if (!newSection) {
        newSection = 
          doc.querySelector(".product-single") ||
          doc.querySelector(".product-section") ||
          doc.querySelector(".product") ||
          doc.querySelector("[class*='product-container']") ||
          doc.querySelector("[data-section-type*='product']") ||
          doc.querySelector("main .shopify-section") ||
          doc.querySelector("#MainContent");
      }

      if (!newSection) throw new Error("New section not found");

      const productData = await productDataPromise;

      const fragment = document.createDocumentFragment();
      Array.from(newSection.childNodes).forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'SCRIPT' && !node.src) return;
        fragment.appendChild(node.cloneNode(true));
      });

      currentSection.innerHTML = '';
      currentSection.appendChild(fragment);

      setTimeout(() => {
        const allSwatches = document.querySelectorAll('.color-swatch');
        allSwatches.forEach(swatch => {
          if (swatch.dataset.productId == productData.id) {
            swatch.classList.add('is-active');
          } else {
            swatch.classList.remove('is-active');
          }
        });
      }, 50);

      window.history.pushState({ handle }, "", `/products/${handle}`);
      const newPageTitle = doc.querySelector("title");
      if (newPageTitle) document.title = newPageTitle.textContent;

      setTimeout(() => reinitializeAllTracking(productData), 100);
      setTimeout(() => window.scrollTo({ top: currentSection.offsetTop - 100, behavior: "smooth" }), 200);

    } catch (err) {
      console.error("Color swatch switch failed:", err);
      window.location.href = `/products/${handle}`;
    } finally {
      btn.classList.remove("loading");
    }
  });
}

function reinitializeAllTracking(productData) {
  // Remember the last selected size before switching
  const lastSelectedSize = window.lastSelectedSize || null;
  
  // Find the variant that matches the remembered size, fallback to first variant
  let variant = lastSelectedSize 
    ? (productData.variants.find(v => v.title === lastSelectedSize) || productData.variants[0])
    : productData.variants[0];
  
  const currency = Shopify?.currency?.active || "USD";

  window.currentProductContext = {
    productId: productData.id,
    variantId: variant.id,
    productTitle: productData.title,
    variantTitle: variant.title,
    price: variant.price / 100,
    compareAtPrice: variant.compare_at_price ? variant.compare_at_price / 100 : null,
    vendor: productData.vendor || "",
    productType: productData.type || "",
    tags: productData.tags || [],
    url: window.location.href,
    imageUrl: productData.featured_image,
    currency: currency
  };

  initColorSwatches();

  // CRITICAL: Re-initialize Motion theme's variant system properly
  setTimeout(() => {
    const productSection = document.querySelector('[data-section-type="product"]');
    const sectionId = productSection?.dataset.sectionId;
    
    if (productSection && sectionId) {
      const variantJsonEl = productSection.querySelector('[data-variant-json]');
      if (variantJsonEl) {
        variantJsonEl.textContent = JSON.stringify(productData.variants);
      }
      
      try {
        if (window.sections && window.sections[sectionId]) {
          if (typeof window.sections[sectionId].onUnload === 'function') {
            window.sections[sectionId].onUnload();
          }
          delete window.sections[sectionId];
        }
        
        if (window.theme && window.theme.Product) {
          window.sections = window.sections || {};
          window.sections[sectionId] = new window.theme.Product(productSection);
        }
      } catch (e) {
        console.error('Theme variant init failed:', e);
      }
    }
    
    // Fallback + size persistence
    setTimeout(() => {
      const masterSelect = document.querySelector('select[name="id"][data-product-select]');
      const sizeInputs = document.querySelectorAll('input[data-variant-input][name="Size"]');
      
      // RESTORE the remembered size selection in UI
      if (lastSelectedSize && sizeInputs.length > 0) {
        const targetInput = Array.from(sizeInputs).find(input => input.value === lastSelectedSize);
        if (targetInput) {
          targetInput.checked = true;
          if (masterSelect) {
            const matchingVariant = productData.variants.find(v => v.title === lastSelectedSize);
            if (matchingVariant) {
              masterSelect.value = matchingVariant.id;
              masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
      
      if (masterSelect && sizeInputs.length > 0) {
        sizeInputs.forEach(input => {
          input.addEventListener('change', function() {
            const selectedSize = this.value;
            const matchingVariant = productData.variants.find(v => v.title === selectedSize);
            
            if (matchingVariant) {
              masterSelect.value = matchingVariant.id;
              masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
              
              window.currentProductContext.variantId = matchingVariant.id;
              window.currentProductContext.variantTitle = matchingVariant.title;
              window.currentProductContext.price = matchingVariant.price / 100;
              window.lastSelectedSize = selectedSize;
            }
          });
        });
      }
      
      if (masterSelect) {
        masterSelect.addEventListener('change', function() {
          const selectedVariantId = this.value;
          const matchingVariant = productData.variants.find(v => v.id == selectedVariantId);
          
          if (matchingVariant) {
            window.currentProductContext.variantId = matchingVariant.id;
            window.currentProductContext.variantTitle = matchingVariant.title;
            window.currentProductContext.price = matchingVariant.price / 100;
            window.lastSelectedSize = matchingVariant.title;
          }
        });
      }
    }, 100);
  }, 250);

  // Shopify features
  try {
    if (typeof Shopify !== 'undefined') {
      if (Shopify.PaymentButton) Shopify.PaymentButton.init();
      if (Shopify.ProductForm) Shopify.ProductForm.init();
    }
  } catch (e) { }

  // Google Analytics 4
  if (typeof gtag === "function") {
    gtag("event", "view_item", {
      currency: currency,
      value: window.currentProductContext.price.toFixed(2),
      items: [{
        item_id: String(variant.id),
        item_name: productData.title,
        item_variant: variant.title,
        item_brand: window.currentProductContext.vendor,
        item_category: window.currentProductContext.productType,
        price: window.currentProductContext.price.toFixed(2),
        quantity: 1
      }]
    });
  }

  // Google Tag Manager
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: currency,
        value: window.currentProductContext.price.toFixed(2),
        items: [{
          item_id: String(variant.id),
          item_name: productData.title,
          item_variant: variant.title,
          item_brand: window.currentProductContext.vendor,
          item_category: window.currentProductContext.productType,
          price: window.currentProductContext.price.toFixed(2),
          quantity: 1
        }]
      }
    });
  }

  // Klaviyo
  if (window._learnq) {
    window._learnq.push(["track", "Viewed Product", {
      ProductID: variant.id,
      ProductName: productData.title,
      ImageURL: productData.featured_image,
      URL: window.currentProductContext.url,
      Price: window.currentProductContext.price,
      CompareAtPrice: window.currentProductContext.compareAtPrice,
      Categories: window.currentProductContext.tags,
      Brand: window.currentProductContext.vendor,
      ProductType: window.currentProductContext.productType
    }]);
  }

  // Aimerce
  setTimeout(() => {
    try {
      window._aimTrack = window._aimTrack || [];
      window._aimTrack.push(['aim_view_item', {
        id: String(productData.id),
        title: productData.title,
        type: window.currentProductContext.productType,
        untranslatedTitle: productData.title,
        url: window.currentProductContext.url,
        vendor: window.currentProductContext.vendor,
        selectedVariant: {
          id: String(variant.id),
          image: {
            url: productData.featured_image,
            altText: productData.title
          },
          price: {
            amount: String(window.currentProductContext.price.toFixed(2)),
            currencyCode: currency
          },
          product: {
            id: String(productData.id),
            title: productData.title,
            type: window.currentProductContext.productType,
            untranslatedTitle: productData.title,
            url: window.currentProductContext.url,
            vendor: window.currentProductContext.vendor
          },
          sku: variant.sku || null,
          title: variant.title,
          untranslatedTitle: variant.title
        }
      }]);
    } catch (e) {
      console.error('Aimerce tracking error:', e);
    }
  }, 500);

  // Judge.me reviews
  if (typeof jdgm !== 'undefined') {
    try {
      document.querySelectorAll('link.jdgm-stylesheet[href*="undefined"]').forEach(el => el.remove());
      if (jdgm.customizePreviewBadge) jdgm.customizePreviewBadge();
      const reviewWidgets = document.querySelectorAll('[data-jdgm-widget]');
      if (reviewWidgets.length > 0 && jdgm.refresh) jdgm.refresh();
    } catch (e) { }
  }

  // Kaching Cart
  if (window.KachingCart && typeof window.KachingCart.refresh === 'function') {
    try { window.KachingCart.refresh(); } catch (e) { }
  }

  // Raleon Loyalty
  if (window.RaleonLoyalty && typeof window.RaleonLoyalty.refresh === 'function') {
    try { window.RaleonLoyalty.refresh(); } catch (e) { }
  }

  setupAddToCartTracking();

  document.dispatchEvent(new CustomEvent('product:loaded', {
    bubbles: true,
    detail: { source: 'color-swatches', product: productData, variant: variant }
  }));

  setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
}

function setupAddToCartTracking() {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  addToCartForms.forEach(form => {
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);
    newForm.addEventListener('submit', function() {
      if (window.currentProductContext) trackAddToCart(window.currentProductContext);
    });
  });

  document.addEventListener('product:added-to-cart', function() {
    if (window.currentProductContext) trackAddToCart(window.currentProductContext);
  });

  document.addEventListener('cart:item-added', function() {
    if (window.currentProductContext) trackAddToCart(window.currentProductContext);
  });
}

function trackAddToCart(context) {
  const { variantId, productTitle, variantTitle, price, vendor, productType, imageUrl, currency } = context;

  // Aimerce add to cart
  try {
    window._aimTrack = window._aimTrack || [];
    window._aimTrack.push(['aim_add_to_cart', {
      id: String(context.productId),
      title: productTitle,
      type: productType,
      vendor: vendor,
      selectedVariant: {
        id: String(variantId),
        title: variantTitle,
        price: {
          amount: String(price.toFixed(2)),
          currencyCode: currency
        }
      }
    }]);
  } catch (e) {
    console.error('Aimerce add-to-cart tracking error:', e);
  }

  // Google Analytics 4
  if (typeof gtag === "function") {
    gtag("event", "add_to_cart", {
      currency: currency,
      value: price.toFixed(2),
      items: [{
        item_id: String(variantId),
        item_name: productTitle,
        item_variant: variantTitle,
        item_brand: vendor,
        item_category: productType,
        price: price.toFixed(2),
        quantity: 1
      }]
    });
  }

  // Google Tag Manager
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: currency,
        value: price.toFixed(2),
        items: [{
          item_id: String(variantId),
          item_name: productTitle,
          item_variant: variantTitle,
          item_brand: vendor,
          item_category: productType,
          price: price.toFixed(2),
          quantity: 1
        }]
      }
    });
  }

  // Klaviyo
  if (window._learnq) {
    window._learnq.push(["track", "Added to Cart", {
      ProductID: variantId,
      ProductName: productTitle,
      ItemPrice: price,
      Quantity: 1,
      CheckoutURL: window.location.origin + '/checkout',
      ImageURL: imageUrl,
      ProductType: productType,
      Brand: vendor
    }]);
  }
}

window.addEventListener("popstate", () => location.reload());

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initColorSwatches);
  document.addEventListener("DOMContentLoaded", setupAddToCartTracking);
} else {
  initColorSwatches();
  setupAddToCartTracking();
}